import {Component, Input, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import { IconComponent } from './icon/icon.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'message-panel',
    template: `
<div class="message_content" [ngClass]="{show: message, passive:passive}">
{{message}}
<icon class="close" (click)="message=''" matIcon="close"></icon>
</div>
`,
    styles: [`
.message_content { overflow: hidden; transition: height 0.4s; background: #F05454; color: #fff; display: flex; align-items: center; }
.message_content { justify-content: center; border-radius: 6px; position:relative; }
.message_content.show {  padding: 10px 40px 10px 20px; margin: 10px 20px 0; }
.message_content .close { position:absolute; top:12px ;right:8px; color:#fff; font-size:18px; cursor:pointer; }
.message_content.passive { background: transparent; color:#999; text-shadow: 1px 1px #FFF;}
.message_content.passive .close { color:#999; text-shadow: 1px 1px #FFF;}

`],
    standalone: true,
    imports: [IconComponent, CommonModule],
})
export class MessagePanelComponent implements OnChanges {
    @Input() message = '';
    @Input() period = 0;
    @Input() passive = false;
    @Input() do_not_show_again_pref:string;
    public height = '';
    ngOnInit(){
        if(this.do_not_show_again_pref){
            const holding_message = this.message;
            this.message = '';
            console.log(this.do_not_show_again_pref);
        }
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.message.currentValue) {
            if (this.period > 0) {
                setTimeout(() => this.message = '', this.period * 1000);
            }
        }
    }
}

